import * as React from "react";
import { IconProps } from "./IconProps";

export const IconArrowUp = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M1.89707 5.60254C1.67754 5.82208 1.67754 6.17801 1.89707 6.39755C2.11661 6.61708 2.47254 6.61708 2.69207 6.39755L5.43708 3.65254L5.43708 9.93755C5.43708 10.2482 5.68892 10.5001 5.99958 10.5001C6.31024 10.5001 6.56208 10.2482 6.56208 9.93755V3.65254L9.30708 6.39754C9.52662 6.61708 9.88255 6.61708 10.1021 6.39754C10.3216 6.17801 10.3216 5.82208 10.1021 5.60254L6.39733 1.89779C6.17766 1.67811 5.8215 1.67811 5.60183 1.89778L1.89707 5.60254Z"
          fill={color}
        />
      </svg>
    );
  },
);
